<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {}
};
</script>

<style lang="scss">
@import './common/font/font.css';
body {
  margin: 0px;
  padding: 0px;
  background-color: #f8f9fa;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif, Microsoft YaHei, SimSun, sans-serif;
  font-size: 12px;
  color: #1e2229;
  -webkit-font-smoothing: antialiased;
}
h1,
h2,
h3,
h4,
h5,
h6,
p,
ul,
li,
ol,
dl,
dt,
dd,
p {
  margin: 0;
  padding: 0;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
a {
  text-decoration: none;
}
// user commin
.user-bg {
  width: 100%;
  min-height: 100%;
  text-align: center;
  background: #06102e url("./assets/img/iologin.jpg") center;
  background-size: cover;
  .user-logo {
    margin: 60px 0 50px 0;
  }
  .user-container {
    width: 600px;
    margin: 0 auto;
    padding-bottom: 20px;
    .form-container {
      width: 600px;
      border-radius: 8px;
      background: #fff;
      padding-bottom: 60px;
      h3 {
        margin: 60px auto 50px auto;
        text-align: center;
        color: #1e2229;
        font-size: 28px;
        display: inline-block;
      }
      .user-form {
        width: 400px;
        margin: 0 auto;
        label {
          display: block;
          text-align: left;
          font-weight: bold;
          font-size: 16px;
        }
        input {
          height: 50px;
          background-color: #f9fbff;
          border-radius: 2px;
          border: solid 1px #d2dcef;
        }
        .el-button--primary {
          width: 400px;
          height: 50px;
          color: #fff;
          font-size: 18px;
          border: none;
          margin: 30px 0 0;
          background-color: #fff !important;
          background-image: linear-gradient(
            90deg,
            #e6c680 0%,
            #f1e0bc 100%
          ) !important;
          border: none;
        }
      }
    }
  }
}
.el-input-group__append,
.el-input-group__prepend {
  color: #fff !important;
  background-image: linear-gradient(90deg, #e6c680 0%, #f1e0bc 100%) !important;
}
.el-button:focus,
.el-button:hover {
  border: none;
  background-image: linear-gradient(90deg, #e6c680 0%, #f1e0bc 100%) !important;
}
.com-user-btn {
  width: 400px;
  height: 50px;
  color: #fff !important;
  border: none !important;
  background-image: linear-gradient(90deg, #e6c680 0%, #f1e0bc 100%) !important;
  border-radius: 2px;
}
.signUp {
  width: 100%;
  font-size: 14px;
  margin-top: 44px;
  text-align: center;
  color: #fff;
  p {
    .go-regi {
      color: #4389f2 !important;
      cursor: pointer;
      margin-left: 10px;
      clear: both;
      text-decoration: none;
    }
  }
}
#app {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
}
.el-submenu [class^="fa"] {
  vertical-align: baseline;
  margin-right: 10px;
}
.el-menu-item [class^="fa"] {
  vertical-align: baseline;
  margin-right: 10px;
}
.el-message {
  z-index: 10002 !important;
}
.container .main .content-container {
  position: relative;
}
.toolbar {
  padding: 10px;
  position: absolute;
  top: 0;
  left: 0;
  h2 {
    float: left;
    margin: 6px 0 0;
    em {
      width: 3px;
      height: 16px;
      display: inline-block;
      vertical-align: middle;
      border-radius: 2px;
      margin-right: 8px;
      background-color: #e6c680;
    }
    span {
      font-size: 16px;
      vertical-align: middle;
    }
  }
  .el-form-item {
    margin-bottom: 10px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// App.vue?b3833912